import React from 'react';
import { SessionStatisticsReport as SessionStatisticsReportData } from '../../models/Report';
import { ExportDropdown } from './ExportDropdown';
import { rowsToCsv, downloadCsv, todayStamp } from '../../utils/csv';

interface Props {
  data: SessionStatisticsReportData;
  onBack?: () => void;
}

export const SessionStatisticsReport: React.FC<Props> = ({ data }) => {
  const handleExportCSV = () => {
    const csv = rowsToCsv(data.sessionsByRBT, [
      { header: 'RBT Name', get: (r) => r.rbtName },
      { header: 'Session Count', get: (r) => r.sessionCount },
      { header: 'Total Hours', get: (r) => r.totalHours },
    ]);
    downloadCsv(`session-statistics_by-rbt_${todayStamp()}.csv`, csv);
  };

  return (
  <div>
    {/* Toolbar */}
    <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 'var(--spacing-4)' }}>
      <ExportDropdown onExportCSV={handleExportCSV} />
    </div>

    {/* Summary Cards */}
    <div className="grid grid-cols-4" style={{ gap: 'var(--spacing-4)', marginBottom: 'var(--spacing-6)' }}>
      <div className="card">
        <div style={{ fontSize: 'var(--text-sm)', color: 'var(--color-gray-600)', marginBottom: 'var(--spacing-2)' }}>
          Total Sessions
        </div>
        <div style={{ fontSize: 'var(--text-3xl)', fontWeight: 'var(--font-bold)' }}>
          {data.totalSessions}
        </div>
      </div>
      <div className="card">
        <div style={{ fontSize: 'var(--text-sm)', color: 'var(--color-gray-600)', marginBottom: 'var(--spacing-2)' }}>
          Completed
        </div>
        <div style={{ fontSize: 'var(--text-3xl)', fontWeight: 'var(--font-bold)', color: 'var(--color-success)' }}>
          {data.completedSessions}
        </div>
      </div>
      <div className="card">
        <div style={{ fontSize: 'var(--text-sm)', color: 'var(--color-gray-600)', marginBottom: 'var(--spacing-2)' }}>
          Total Hours
        </div>
        <div style={{ fontSize: 'var(--text-3xl)', fontWeight: 'var(--font-bold)' }}>
          {data.totalSessionHours}
        </div>
      </div>
      <div className="card">
        <div style={{ fontSize: 'var(--text-sm)', color: 'var(--color-gray-600)', marginBottom: 'var(--spacing-2)' }}>
          Avg Duration (min)
        </div>
        <div style={{ fontSize: 'var(--text-3xl)', fontWeight: 'var(--font-bold)' }}>
          {data.averageSessionDuration}
        </div>
      </div>
    </div>

    {/* Sessions by RBT */}
    <div className="card" style={{ marginBottom: 'var(--spacing-6)' }}>
      <h3 style={{ marginBottom: 'var(--spacing-4)' }}>Sessions by RBT</h3>
      <div className="table-container">
        <table className="table">
          <thead>
            <tr>
              <th>RBT Name</th>
              <th>Session Count</th>
              <th>Total Hours</th>
            </tr>
          </thead>
          <tbody>
            {data.sessionsByRBT.map((rbt) => (
              <tr key={rbt.rbtId}>
                <td>{rbt.rbtName}</td>
                <td>{rbt.sessionCount}</td>
                <td>{rbt.totalHours}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>

    {/* Sessions by Client */}
    <div className="card">
      <h3 style={{ marginBottom: 'var(--spacing-4)' }}>Sessions by Client</h3>
      <div className="table-container">
        <table className="table">
          <thead>
            <tr>
              <th>Client</th>
              <th>Session Count</th>
              <th>Total Hours</th>
            </tr>
          </thead>
          <tbody>
            {data.sessionsByClient.map((client) => (
              <tr key={client.clientId}>
                <td>{client.clientName}</td>
                <td>{client.sessionCount}</td>
                <td>{client.totalHours}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
  );
};
